// src/rotas.js

export const categoriasFixas = [
  { nome: "Home", rota: "/" },
  { nome: "+Lanches", rota: "/produto2" },
  { nome: "Bebidas", rota: "/bebidas" },
  { nome: "Sucos", rota: "/sucos" },
  { nome: "Omeletes", rota: "/omeletes" },
  { nome: "Acréscimos", rota: "/acrescimo" },
  { nome: "Açaí", rota: "/acai" },
];

export const rotas = {
  home: "/",
  checkout: "/checkout",
  lanches: "/lanches",
  produto2: "/produto2",
  omeletes: "/omeletes",
  bebidas: "/bebidas",
  sucos: "/sucos",
  acrescimo: "/acrescimo",
  acai: "/acai",
  loginAdmin: "/login-admin",
  adminPedidos: "/admin",
  adminEstatisticas: "/admin-estatisticas",
  adminProdutos: "/admin-produtos",
};
